import getAxiosClient from "@lib/getAxiosClient";
import { apiConfig } from "apiConfig";
import { useCallback } from "react";

export interface FileUploadDetails {
  name: string;
  size: number;
  mimetype: string;
  fileName: string;
}

export function useLeadGenFormSubmission() {
  const postFormAndFiles = useCallback(
    async (files: File[] | null, formData: any, formName: string) => {
      const filesToUpload = files ?? [];

      const client = getAxiosClient(
        "",
        {
          baseURL: apiConfig.productCloudApiOrigin,
        },
        undefined,
        false,
        false
      );

      const fd = new FormData();
      for (const file of filesToUpload) {
        fd.append("uploadfiles", file);
      }

      fd.append("formData", JSON.stringify(formData));
      fd.append("formName", formName);

      return client.post("/lead-gen-upload", fd);
    },
    []
  );

  return {
    postFormAndFiles,
  };
}
